import Alpine from 'alpinejs';

Alpine.data('generateContract', (adminURL, postId, userEmail) => ({
  adminURL,
  errors: [],
  loadingGenerate: false,
  successGenerate: false,
  loadingSend: false,
  successSend: false,
  wage: '',
  wage_in_words: '',
  type: '',
  // init() {
  //   this.fetchDocuments();
  // },
  // fetchDocuments() {
  //   this.loading = true;

  //   const formData = new FormData();
  //   formData.append('action', 'getDocumentsTemplates');

  //   fetch(this.adminURL, {
  //     method: 'POST',
  //     body: formData,
  //   })
  //     .then((res) => res.json())
  //     .then((res) => {
  //       this.loading = false;

  //       this.items = res;
  //     });
  // },
  setFilter(e) {
    const by = e.detail.by;
    this.type = by;
  },
  generate() {
    if (!this.wage || !this.type) return;

    this.loadingGenerate = true;

    const formData = new FormData();
    formData.append('action', 'generateContract');

    formData.append('post_id', postId);
    formData.append('user_email', userEmail);

    formData.append('wage', this.wage);
    formData.append('wage_in_words', this.wage_in_words);
    formData.append('type', this.type);

    fetch(this.adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        // console.log('xdxd', res);
        // const submitFormBtn = document.querySelector('.wpcf7-submit');
        // submitFormBtn.click();

        this.successGenerate = true;

        this.loadingGenerate = false;
      });
  },

  fillForm() {
    const form = document.querySelector('.wpcf7');

    const userNameInput = form.querySelector('input[name="user_email"]');
    userNameInput.value = userEmail;
  },

  send() {
    this.loadingSend = true;

    // this.fillForm();

    const formData = new FormData();
    formData.append('action', 'acceptContract');
    formData.append('post_id', postId);
    formData.append('user_email', userEmail);

    fetch(this.adminURL, {
      method: 'POST',
      body: formData,
    })
    then((res) => res.json())
      .then((res) => {
        this.successSend = res.success;
        this.loadingSend = false;
      })
      .catch(() => {
        this.successSend = false;
        this.loadingSend = false;
      });
  },
}));
